module.exports = __webpack_public_path__ + "cc6623244f1fc4a86c7ad084ab7fa454.MP3";